import React, { useEffect, useState } from "react";
import { ReactComponent as PlusIcon } from "../assets/plus_icon_primary.svg";

import AlignerImage from "./../assets/aligner.png";
import { Link, useNavigate } from "react-router";
import {
  DESCRIPTION_COLOR,
  PRIMARY_COLOR,
  SECONDARY_COLOR,
} from "../constants/theme";
import { FaMagnifyingGlass } from "react-icons/fa6";
import { sidebarItems } from "../constants/sidebar";
import { toast } from "react-toastify";
import { getPatientCaseData } from "../services/patient/patient.service";
import Loader from "../components/Loader";
import { getLatestScheduleByPatientId } from "../services/drSchedule/drSchedule.service";

const HomeScreen = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [latestCase, setLatestCase] = useState({});

  const email = sessionStorage.getItem("email");
  const clinic = JSON.parse(sessionStorage.getItem("clinicCode") || "[]");
  let clinicCode = undefined;
  if (clinic.length > 0) {
    clinicCode = clinic[0].clinic_code;
  }

  const patientId = sessionStorage.getItem("patientId");

  const [screenWidth, setScreenWidth] = useState(0);
  console.log(screenWidth);

  const getPatientCases = async () => {
    try {
      setLoading(true);

      if (!clinicCode) {
        return toast.error("No associated clinic found. Contact support!");
      }
      if (!patientId) {
        toast.error("Data error! Login again!");
        sessionStorage.clear();
        navigate("/login");
        return;
      }
      const response = await getPatientCaseData(email, patientId, "1", 0);
      if (response.status === 200) {
        setLatestCase(response?.data?.data[0]);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("ERROR FETCHING PATIENT CASE DATA => ", error);
      // return toast("Server error. Try again later!");
    }
  };

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  useEffect(() => {
    getPatientCases();
  }, []);

  return (
    <div className="position-relative col-12 p-0" style={{ zIndex: "20" }}>
      <div className="row w-100 mx-auto flex-column align-items-center justify-content-between">
        <div className="col-12 p-0">
          <div
            className=""
            style={{
              backgroundColor: "rgb(255, 255, 255)",
              // padding: "13px 13px 32px 13px",
              marginLeft: "10px",
              marginRight: "10px",
              borderRadius: "15px",
              height: "90vh",
              minHeight: "780px",
            }}
          >
            <div
              style={{
                padding: "5px 0px",
              }}
            ></div>
            <div
              className="row w-100 mx-auto"
              style={{
                marginTop: "18px",
                lineHeight: "1.1",
                gap: "22px",
                // maxHeight: '65vh',
                // overflowY: "scroll",
                scrollBehavior: "smooth",
              }}
            >
              <div className="col-md-12 px-sm-4">
                <Link
                  className="row w-100 mx-auto align-items-center justify-content-start justify-content-sm-center card-hover-effect text-decoration-none"
                  style={{
                    padding: "14px 6px 14px 14px",
                    backgroundColor: "rgb(203, 108, 230)",
                    borderRadius: "16px",
                    gap: "12px",
                    cursor: "pointer",
                    color: "white",
                  }}
                  to="/appointment"
                >
                  <div className="col-auto p-0">
                    <div
                      className=""
                      style={{
                        height: "50px",
                        width: "50px",
                      }}
                    >
                      <PlusIcon />
                    </div>
                  </div>
                  <div className="col col-sm-auto p-0">
                    <div
                      className="d-flex flex-column justify-content-center"
                      style={{
                        fontSize: "17px",
                        color: "#ffffff",
                        gap: "2px",
                        maxWidth: "180px",
                        minWidth: "180px",
                      }}
                    >
                      <div>Book Appointment</div>
                      <div
                        className=""
                        style={{
                          fontSize: "10px",
                          lineHeight: "1.25",
                        }}
                      >
                        Check the availability of doctors
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
              {/* {topMenuItems.map((item, index) => {
                return ( */}
              {/* <div className="col-12 p-0 px-sm-4" key={index}> */}
              {!loading && latestCase && latestCase?.case_id && (
                <div className="col-12 px-sm-4">
                  <div
                    className="row w-100 mx-auto align-items-center justify-content-start justify-content-sm-center card-hover-effect"
                    style={{
                      padding: "14px 6px 14px 14px",
                      backgroundColor: "rgb(203, 108, 230)",
                      borderRadius: "16px",
                      gap: "12px",
                      cursor: "pointer",
                    }}
                    onClick={(e) => {
                      sessionStorage.setItem(
                        "case",
                        JSON.stringify(latestCase)
                      );
                      navigate("/view-case");
                    }}
                  >
                    <div className="col-auto p-0">
                      <div
                        className="d-flex align-items-center justify-content-center"
                        style={{
                          height: "50px",
                          width: "50px",
                        }}
                      >
                        <img
                          className="w-100"
                          // src={selectedItem?.icon}
                          src={AlignerImage}
                          alt="aligner"
                          style={{}}
                        />
                      </div>
                    </div>
                    <div className="col col-sm-auto p-0">
                      <div
                        className="d-flex flex-column justify-content-center"
                        style={{
                          fontSize: "17px",
                          color: "#ffffff",
                          gap: "4px",
                          maxWidth: "190px",
                          minWidth: "180px",
                        }}
                      >
                        <div className="" style={{}}>
                          {latestCase?.current_status}
                        </div>
                        {/* <small style={{ fontSize: "10px" }}>
                          {latestCase?.case_id}
                        </small> */}

                        <div
                          className=""
                          style={{
                            fontSize: "10px",
                            lineHeight: "1.25",
                          }}
                        >
                          Review your aligners plan
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {loading && <Loader />}
              {/* );  })} */}
            </div>
            {/* <BottomMenuBar /> */}

            <hr />
            <div
              className="row w-100 mx-auto flex-column align-items-center"
              style={{
                gap: "26px",
                marginTop: "18px",
              }}
            >
              {/* <div className="col-12 position-relative">
                <input
                  placeholder="SEARCH"
                  className="search-input w-100"
                  style={{
                    border: `1px solid ${SECONDARY_COLOR}`,
                    borderRadius: "20px",
                    color: SECONDARY_COLOR,
                    fontSize: "12px",
                    padding: "4px 12px",
                    backgroundColor: "unset",
                    outline: "none",
                    paddingInlineEnd: "28px",
                    textAlign: "center",
                  }}
                />
                <div
                  className="position-absolute d-flex align-items-center justify-content-center"
                  style={{
                    right: "20px",
                    top: "0",
                    height: "100%",
                  }}
                >
                  <FaMagnifyingGlass
                    style={{
                      height: "14px",
                      width: "14px",
                      color: SECONDARY_COLOR,
                    }}
                  />
                </div>
              </div> */}

              <div className="col-12 p-0">
                <div
                  className="row w-100 mx-auto align-items-center"
                  style={{
                    rowGap: "28px",
                  }}
                >
                  {sidebarItems.map((item, index) => {
                    return (
                      <div
                        className="col-6 col-sm-4 p-0 text-decoration-none"
                        // to={item?.link}
                        key={index}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (item?.link === "/appointment-view") {
                            if (!sessionStorage.getItem("appointmentId")) {
                              toast.error("Book an appointment");
                            } else {
                              navigate(item?.link);
                            }
                          } else {
                            navigate(item?.link);
                          }
                        }}
                      >
                        <div className="row w-100 mx-auto align-items-center justify-content-center">
                          <div className="col-auto p-0">
                            <div className="d-flex flex-column align-items-center justify-content-center">
                              <img
                                className=""
                                // src={item?.icon}
                                src={item?.image}
                                alt="sidebar item"
                                style={{
                                  width: "80px",
                                  height: "80px",
                                }}
                              />

                              <div
                                className="d-flex flex-column align-items-center justify-content-center text-center"
                                style={{
                                  lineHeight: "1",
                                  gap: "4px",
                                }}
                              >
                                <div
                                  className=""
                                  style={{
                                    fontSize: "13px",
                                    color: PRIMARY_COLOR,
                                    fontWeight: "600",
                                    // textDecoration: "underline",
                                    textDecorationThickness: "0.115em",
                                  }}
                                >
                                  {item.title}
                                </div>
                                <div
                                  className="text-center"
                                  style={{
                                    fontSize: "10px",
                                    color: DESCRIPTION_COLOR,
                                    fontWeight: "400",
                                    maxWidth: "80px",
                                    lineHeight: "1.15",
                                    // marginTop: '3px'
                                  }}
                                >
                                  {item.des}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeScreen;
